export default __webpack_public_path__ + "../img/g500_media_contacts.jpg";